import React, { useState, useCallback, useEffect } from 'react'
import {
    Page,
    Layout,
    Card,
    FormLayout,
    TextField,
    DropZone,
    Thumbnail,
    Spinner,
    Toast,
    Stack
} from '@shopify/polaris'
import { useHistory } from 'react-router-dom'
import store from 'store-js'
import axios from 'axios'

const Edit = () => {

    const history = useHistory();

    const metafield = store.get('metafield')
    const orderId = store.get('orderid')
    // const orderName = store.get('ordername')
    // const orderemail = store.get('orderemail')

    const [files, setFiles] = useState([])
    const [saveBtnStatus, setSaveBtnStatus] = useState(true)
    const [addedImage, setAddedImage] = useState([])
    const [loaded, setLoaded] = useState(false)
    const [orderemail, setOrderemail] = useState('')
    const [orderName, setOrderName] = useState('')
    const [successToast, setSuccessToast] = useState(false)
    const [errorToast, setErrorToast] = useState(false)

    const handleDropZoneDrop = useCallback(
      (_dropFiles, acceptedFiles, _rejectedFiles) => {
        setFiles((files) => [...files, ...acceptedFiles])
        setSaveBtnStatus(false)
      },
      [],
    );

    const fetchOrderDetails = async () => {
      axios(`/orders/getorder?orderid=${orderId}`).then(res => {
          setAddedImage([...res.data.fileLocation]);
          setFiles([...res.data.fileLocation]);
          console.log("image fetched",res.data);
      }).catch((e)=>{
          console.log("Error",e);

      }).finally(()=>{
          setLoaded(true);
      });
      
      if (!metafield) {
          setLoaded(true)
          setAddedImage('https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304')
          // return
      }
    }

    useEffect(() => {
        setOrderName(store.get('ordername'))
        setOrderemail(store.get('orderemail'))
        fetchOrderDetails()
    }, [orderId]);

    const handleSubmit = async () => {
      setLoaded(false)
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('myFile', files[i]);
      }

      // formData.append('myFile', files)
      formData.append('orderID', orderId)
      formData.append('orderName', orderName)
      formData.append('orderEmail', orderemail)

      try{
        const resp = await axios.post('/orders/add', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        setAddedImage(resp.data.fileLocation)
        setLoaded(true)
        setSuccessToast(true)
        setSaveBtnStatus(true)
        fetchOrderDetails()
      } catch (error) {
        console.log(error)
        setErrorToast(true)
      }
    }

    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

    return (
        <Page
            breadcrumbs={[{content: 'Home', onAction: () => history.push('/')}]}
            title="West n Willow Order Image"
            primaryAction={{content: 'Save', disabled: saveBtnStatus, onAction: handleSubmit}}
            separator>
            <Layout>
                <Layout.AnnotatedSection
                    title="Order details"
                    description={'Order Name: ' + orderName}
                >
                    <Card sectioned>
                        {!loaded && (<Spinner accessibilityLabel="Spinner" size="large" color="teal" />)}
                        <FormLayout>
                            <TextField label="Order ID" value={orderName} disabled />
                            <TextField type="email" label="Order email" value={orderemail} disabled/>
                            <Stack horizontal>
                              {/* { addedImage.map((file, index) => (
                                <Stack alignment="center" key={index}>
                                  <Thumbnail
                                    size="small"
                                    // alt={file.name}
                                    source={
                                     file
                                    }
                                  />

                                </Stack>
                              ))}  */}
                              {files.map((file, index) => (
                                <div alignment="center" key={index}
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                    columnGap: "10px"
                                  }}
                                >
                                  {/* <Thumbnail
                                    size="small"
                                    alt={file?.name}
                                    source={
                                      validImageTypes.indexOf(file.type) > 0
                                        ? window.URL.createObjectURL(file)
                                        : file || 'https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304'
                                    }
                                  /> */}

                                  <img src={
                                    validImageTypes.indexOf(file?.type) > 0
                                    ? window.URL.createObjectURL(file)
                                    : file || 'https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304'
                                  }
                                  alt=""
                                  width={`100px`}
                                  height={`100px`}
                                  />

                                </div>
                              ))}
                            </Stack>

                            <div style={{width: 114, height: 114}}>
                              <DropZone allowMultiple={true} onDrop={handleDropZoneDrop} label="Image">
                                <DropZone.FileUpload />
                              </DropZone>
                            </div>
                        </FormLayout>
                    </Card>
                </Layout.AnnotatedSection>
            </Layout>
            { successToast && (<Toast content="Image Saved!" onDismiss={() => setSuccessToast(false) } />) }
            { errorToast && (<Toast content="Something went wrong!" error onDismiss={() => setErrorToast(false) } />)}
        </Page>
    )
}


export default Edit